import Slider, { SliderProps } from '@react-native-community/slider'

interface IRangeInputProps extends SliderProps {
  foregroundColor?: string
  rangeColor?: string
  min?: number
  max?: number
  height?: number
}

export function RangeInput({
  min = 0,
  max = 100,
  foregroundColor = '$neutral-200',
  rangeColor = '$primary-300',
  onValueChange,
  value,
  children,
}: IRangeInputProps) {
  return (
    <Slider
      style={{
        width: '100%',
      }}
      minimumValue={min}
      maximumValue={max}
      minimumTrackTintColor={rangeColor}
      maximumTrackTintColor={foregroundColor}
      value={value}
      onValueChange={onValueChange}
      thumbTintColor={rangeColor}
      step={1}
    >
      {children}
    </Slider>
  )
}
